// extracted by mini-css-extract-plugin
var _1 = "InitialSignUpScreen-module__content___hZxjr";
var _2 = "InitialSignUpScreen-module__create___UfRE5";
var _3 = "InitialSignUpScreen-module__divider___G8YwO";
var _4 = "InitialSignUpScreen-module__inline___OSSie";
var _5 = "InitialSignUpScreen-module__signUpLogInContainer___Lytfu";
export { _1 as "content", _2 as "create", _3 as "divider", _4 as "inline", _5 as "signUpLogInContainer" }
